import { useState, useEffect } from 'react'
import { useLDClient } from 'gatsby-plugin-launchdarkly'

// @NOTE Docs on how this is used https://github.com/gremlin/gremlin-gatsby/wiki/Feature-Flags
export default function useLaunchDarklyClient() {
  const client = useLDClient()

  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (client) {
      setReady(true)
    }
  }, [client])

  return {
    ready,
    client,
  }
}
